import once from 'lodash/once';
const noopExecutor = () => { };
/**
 * Deferred promise allowing external control of resolve / reject.
 */
export class Defer extends Promise {
    resolveFn;
    rejectFn;
    ensureNoopCatchAttached;
    settled = false;
    constructor(executor = noopExecutor) {
        let localResolve;
        let localReject;
        super((resolve, reject) => {
            localResolve = resolve;
            localReject = reject;
            executor(resolve, reject);
        });
        if (localResolve === undefined) {
            throw new Error('invariant violation: resolveFn was undefined');
        }
        if (localReject === undefined) {
            throw new Error('invariant violation: rejectFn was undefined');
        }
        this.resolveFn = localResolve;
        this.rejectFn = localReject;
        this.ensureNoopCatchAttached = once(() => {
            super.catch(() => { });
        });
    }
    resolve(value) {
        this.ensureNoopCatchAttached();
        if (!this.settled) {
            this.settled = true;
            this.resolveFn(value);
        }
    }
    reject(error) {
        this.ensureNoopCatchAttached();
        if (!this.settled) {
            this.settled = true;
            this.rejectFn(error);
        }
    }
    wrap(fn) {
        this.ensureNoopCatchAttached();
        return async (...args) => {
            try {
                const value = await fn(...args);
                this.resolve(value);
                return value;
            }
            catch (err) {
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                this.reject(err);
                throw err;
            }
        };
    }
}
//# sourceMappingURL=Defer.js.map